import enviro from 'enviro';
import { HubletOption } from 'signup-constants/signupData/HubletOption';
export const getIsQa = enviro.isQa;
export const isQA = enviro.isQa();
export const isLocal = isQA && !enviro.deployed();
export const isProd = enviro.isProd();
export const getHubSpotDomain = () => {
  return isQA ? 'hubspotqa.com' : 'hubspot.com';
};
export const getDomainSuffix = () => {
  return isQA ? 'qa' : '';
};
export const getCurrentDomain = () => {
  const prefix = !enviro.deployed() ? 'local' : 'app';
  return `https://${prefix}.${getHubSpotDomain()}`;
};
export const getApplicationDomain = (hublet = HubletOption.na1) => {
  const subdomain = hublet === HubletOption.na1 ? 'app' : `app-${hublet}`;
  return `https://${subdomain}.${getHubSpotDomain()}`;
};
export const getEnv = () => {
  // eslint-disable-next-line no-nested-ternary
  return enviro.deployed() ? enviro.isQa() ? 'qa' : 'prod' : 'local';
};